/**
 * Latest Product section — slider behaviour.
 *
 * Initialises one Swiper per section instance from the theme's global
 * swiper-bundle.min.js (loaded in layout/theme.liquid), reading its
 * per-instance options off data-* attributes so the Liquid stays the single
 * source of the merchant's settings.
 *
 * Scoped entirely to [data-section-type="latest-product"] — it never queries
 * or touches any other section's markup.
 */
(function () {
  "use strict";

  var SECTION_SELECTOR = '[data-section-type="latest-product"]';

  function toInt(value, fallback) {
    var parsed = parseInt(value, 10);
    return isNaN(parsed) ? fallback : parsed;
  }

  function initSection(section) {
    if (!section || section.latestProductSwiper) return;
    if (typeof window.Swiper !== "function") return;

    var sliderEl = section.querySelector("[data-latest-slider]");
    if (!sliderEl) return;

    var perViewDesktop = toInt(section.dataset.columnsDesktop, 3);
    var loop = section.dataset.loop === "true";
    var slideCount = sliderEl.querySelectorAll(".swiper-slide").length;

    section.latestProductSwiper = new window.Swiper(sliderEl, {
      slidesPerView: 1,
      spaceBetween: 16,
      /* Looping with fewer slides than are shown leaves Swiper with nothing to
         duplicate and it renders blank gaps — only loop when there is room. */
      loop: loop && slideCount > perViewDesktop,
      /* watchOverflow would hide the pagination and disable the arrows
         whenever the slides fit in one view — which made the controls vanish
         with no way for the merchant to bring them back. The section's own
         "Show navigation buttons" / "Show pagination" settings are the single
         source of truth for whether the controls exist, so this stays off and
         Liquid simply does not render a control that is switched off. */
      watchOverflow: false,
      a11y: { enabled: true },
      navigation: {
        prevEl: section.querySelector("[data-latest-prev]"),
        nextEl: section.querySelector("[data-latest-next]")
      },
      pagination: {
        el: section.querySelector("[data-latest-pagination]"),
        clickable: true
      },
      breakpoints: {
        750: { slidesPerView: Math.min(2, perViewDesktop), spaceBetween: 18 },
        990: { slidesPerView: perViewDesktop, spaceBetween: 20 }
      }
    });
  }

  function destroySection(section) {
    if (section && section.latestProductSwiper) {
      section.latestProductSwiper.destroy(true, true);
      section.latestProductSwiper = null;
    }
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener("shopify:section:load", function (event) {
      var section = event.target.querySelector(SECTION_SELECTOR);
      if (section) window.setTimeout(function () { initSection(section); }, 100);
    });
    document.addEventListener("shopify:section:unload", function (event) {
      destroySection(event.target.querySelector(SECTION_SELECTOR));
    });
  }
})();
